/* eslint-disable react/no-danger */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import A from '../A';
import styles from './styles';
var useStyles = createUseStyles(styles);
var Footer = function Footer(props) {
  var classesProp = props.classes,
    className = props.className,
    links = props.links,
    cookieButton = props.cookieButton;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  return /*#__PURE__*/React.createElement("footer", {
    className: cx(classes.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes.contentLeft
  }, cookieButton && /*#__PURE__*/React.createElement("li", {
    key: "cookie-settings"
  }, cookieButton), links && links.map(function (link, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(A, link, link.text));
  }))));
};
Footer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.shape(A.propTypes)),
  cookieButton: PropTypes.node
};
Footer.defaultProps = {
  className: null,
  classes: {},
  links: null,
  cookieButton: null
};
export default withMemo()(Footer);